import addElement from '../helpers/addElement';

class Dates {
  constructor() {
    this.instance = null;
  }

  init(instance) {
    this.instance = instance;
    this.instance.addTaskLayer({
      renderer: {
        render: task => this.renderDatesOnDrag(task),
        getVisibleRange: instance.getVisibleTasksRange,
      },
      filter(task) {
        return instance.config.show_drag_vertical && task.id == instance.getState().drag_id;
      },
    });
  }

  renderDatesOnDrag(task) {
    const state = this.instance.getState();
    let paddingStart = 0;
    let paddingEnd = 0;
    const paddongDeltaPx = 15;
    let copy;

    if (state.drag_mode !== 'progress') {
      copy = task;
    } else {
      copy = this.instance.__scaleTask(task);
    }

    if (state.drag_mode === 'resize') {
      if (state.drag_from_start) {
        copy.start_date = task.start_date;
        paddingEnd = paddongDeltaPx;
      }

      if (!state.drag_from_start) {
        copy.end_date = task.end_date;
        paddingStart = paddongDeltaPx;
      }
    } else if (state.drag_mode === 'move') {
      copy = task;
    }

    const sizes = this.instance.getTaskPosition(copy, copy.start_date, copy.end_date);
    const wrapper = document.createElement('div');

    if (state.drag_mode !== 'progress' && task.type !== 'project') {
      addElement({
        css: 'drag_move_start drag_date',
        left: `${sizes.left - this.instance.config.drag_label_width - paddingStart}px`,
        top: `${sizes.top}px`,
        width: `${this.instance.config.drag_label_width}px`,
        height: `${this.instance.config.row_height}px`,
        html: this.instance.templates.drag_date(copy.start_date),
        wrapper,
      });

      addElement({
        css: 'drag_move_end drag_date',
        left: `${sizes.left + sizes.width + paddingEnd}px`,
        top: `${sizes.top}px`,
        width: `${this.instance.config.drag_label_width}px`,
        height: `${this.instance.config.row_height}px`,
        html: this.instance.templates.drag_date(copy.end_date),
        wrapper,
      });
    }

    return wrapper;
  }
}

export default new Dates();
